module.exports = __webpack_public_path__ + "static/media/AB_B2_1.59931893.jpg";